import { jsx } from 'react/jsx-runtime';
import { useTimeout } from '@flex-design-system/fx-utils/hooks';
import { forwardRef, useCallback, useImperativeHandle, useEffect } from 'react';
import { StyledToastRoot, toastTransition } from './styled.mjs';

function getAutoClose(autoClose, toast) {
  if (typeof toast.autoClose === "number") {
    return toast.autoClose;
  }
  if (toast.autoClose === false || autoClose === false) {
    return false;
  }
  return autoClose;
}
const TimeoutContainer = forwardRef(function TimeoutContainer2({ children, toast, onHide, autoClose, ...props }, ref) {
  const { setTimeout, clearTimeout } = useTimeout({ clearOnNewTimeout: true });
  const hideToast = useCallback(() => {
    onHide(toast.id);
    clearTimeout();
  }, [onHide, toast.id, clearTimeout]);
  useImperativeHandle(
    ref,
    () => ({
      hide: hideToast
    }),
    [hideToast]
  );
  const autoCloseTimeout = getAutoClose(autoClose, toast);
  useEffect(() => {
    toast.onOpen?.(toast);
  }, [toast]);
  useEffect(() => {
    if (typeof autoCloseTimeout === "number") {
      setTimeout(hideToast, autoCloseTimeout);
      return clearTimeout;
    }
  }, [autoCloseTimeout, clearTimeout, hideToast, setTimeout, toast]);
  return /* @__PURE__ */ jsx(StyledToastRoot, { ...toastTransition(), ...props, children });
});

export { TimeoutContainer as default };
//# sourceMappingURL=TimeoutContainer.mjs.map
